import { useQuery } from "@tanstack/react-query";
import { getClientConnection } from "../services/api";
import { Connection } from "@/types/api";

export const useConnection = (clientId: string, connectionId: string) => {
  const { data: connection, isLoading: isLoadingConnection, error: connectionError } = useQuery<Connection>({
    queryKey: ["connection", clientId, connectionId],
    queryFn: () => getClientConnection(clientId, connectionId),
    enabled: Boolean(clientId && connectionId),
    staleTime: 0,
    retry: false,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  return {
    connection,
    isLoadingConnection,
    connectionError,
  };
};